import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-37069571"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex buttons" }

import { ref, watch } from "vue";
import Dialog from "primevue/dialog";
import Button from "primevue/button";

import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'ImportantChangesDialog',
  props: {
    visible: { type: Boolean },
    objectName: {}
  },
  emits: ["close", "edit"],
  setup(__props: any, { emit: __emit }) {

const router = useRouter();

const props = __props;

const emits = __emit;

const visibleLocal = ref(props.visible);
watch(
  () => props.visible,
  (newValue) => {
    visibleLocal.value = newValue;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: visibleLocal.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visibleLocal).value = $event)),
    onHide: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close'))),
    modal: "",
    header: "Подтверждение",
    style: { width: '30rem' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", null, "Вы уверены, что хотите редактировать этот " + _toDisplayString(_ctx.objectName) + "? С ним могут быть созданы сегменты или запущены рекламные кампании. Информация изменится во всех существующих объектах системы.", 1),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Button), {
          type: "button",
          label: "Редактировать",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('edit')))
        }),
        _createVNode(_unref(Button), {
          type: "button",
          label: "Отменить",
          severity: "secondary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        })
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})